import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Horizontal scroll row with snap, no-scrollbar, and prev/next arrows. */
export default function Carousel({ children, testid }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    if (!ref.current) return;
    const w = ref.current.clientWidth;
    ref.current.scrollBy({ left: dir * w * 0.9, behavior: "smooth" });
  };
  return (
    <div className="relative group" data-testid={testid}>
      <button
        onClick={() => scroll(-1)}
        className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-10 h-10 bg-white border border-[#E5E3DD] items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-[#F3F2F0]"
        aria-label="Previous"
        data-testid={`${testid}-prev`}
      >
        <ChevronLeft className="w-4 h-4" strokeWidth={1.5} />
      </button>
      <div
        ref={ref}
        className="flex gap-3 md:gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2"
      >
        {React.Children.map(children, (child, i) => (
          <div key={i} className="snap-start shrink-0 w-[46%] sm:w-[30%] md:w-[22%] lg:w-[18%]">
            {child}
          </div>
        ))}
      </div>
      <button
        onClick={() => scroll(1)}
        className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-10 h-10 bg-white border border-[#E5E3DD] items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-sm hover:bg-[#F3F2F0]"
        aria-label="Next"
        data-testid={`${testid}-next`}
      >
        <ChevronRight className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
}
